import { useAtomValue, WritableAtom } from 'jotai';
import { SetStateAction } from 'react';
import { isEqual } from 'lodash';
import { useCustomFieldFromQueryCache } from 'admin/customFields/hooks/useCustomFieldFromQueryCache';
import { DropdownCustomFieldChips } from './DropdownCustomFieldChips';
import { TextCustomFieldChip } from './TextCustomFieldChip';

type CustomFieldsProps = {
  customFieldsAtom: WritableAtom<
    Record<string, string | string[]>,
    [SetStateAction<Record<string, string | string[]>>],
    void
  >;
};

export const CustomFieldsChips = ({ customFieldsAtom }: CustomFieldsProps) => {
  const customFields = useAtomValue(customFieldsAtom);

  const { data: customFieldsData, isFetched } = useCustomFieldFromQueryCache();

  const entries = Object.entries(customFields).filter(
    ([, customFieldFilterValue]) =>
      customFieldFilterValue !== '' && !isEqual(customFieldFilterValue, []),
  );

  return entries.map(([customFieldId, customFieldFilterValue]) => {
    const isDropdownCustomField = Array.isArray(customFieldFilterValue);
    return isDropdownCustomField ? (
      <DropdownCustomFieldChips
        isLoading={!isFetched}
        customFieldDefinitions={customFieldsData}
        customFieldDefinitionId={customFieldId}
        customFieldSelectedOptionIds={customFieldFilterValue}
        customFieldsAtom={customFieldsAtom}
      />
    ) : (
      <TextCustomFieldChip
        isLoading={!isFetched}
        customFieldDefinitions={customFieldsData}
        customFieldDefinitionId={customFieldId}
        customFieldValue={customFieldFilterValue}
        customFieldsAtom={customFieldsAtom}
      />
    );
  });
};
